import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledCheckbox = styled.button<{ disabled?: boolean }>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  padding: 0;
  border: none;
  background-color: ${colorsPalettes.carbon[0]};
  display: inline-flex;
  align-items: center;

  ${SWReactIcons} {
    flex: none;
  }
`;

export const StyledCheckboxLabel = styled.span`
  width: 100%;
  text-align: left;
  margin: 0 8px;
  ${setFontVariant('body1', colorsPalettes.carbon[300])};

  a {
    color: ${colorsPalettes.blue[400]};
    text-decoration: none;
  }
`;
